package com.castly.shared.dto

import kotlinx.serialization.Serializable

@Serializable
data class ReaderDto(
    val id: Int,
    val name: String,
    val biography: String? = null,
    val audiobookCount: Int? = null,
    val createdAt: String? = null,
    val updatedAt: String? = null
)

@Serializable
data class CreateReaderRequest(
    val name: String,
    val biography: String? = null
)

@Serializable
data class UpdateReaderRequest(
    val name: String? = null,
    val biography: String? = null
)

@Serializable
data class ReaderListResponse(
    val readers: List<ReaderDto>,
    val total: Int,
    val page: Int,
    val pageSize: Int
)

@Serializable
data class ReaderDetailResponse(
    val reader: ReaderDto,
    val audiobooks: List<AudiobookDto>
)

@Serializable
data class MergeReaderRequest(
    val sourceReaderId: Int,
    val targetReaderId: Int
)

@Serializable
data class MergeReaderResponse(
    val targetReader: ReaderDto,
    val mergedCount: Int
)
